import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useLocation, useParams } from "react-router-dom";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Properties/Tables";
import EditDetail from "../../Components/Properties/EditDetail";
import ViewDetail from "../../Components/Properties/ViewDetail";
import ViewDocument from "../../Components/Properties/ViewDocument";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";

import {
  FieldWrapper,
  InputGroup,
  Label,
  SubmitBtn,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import AddFloor from "../../Components/Properties/AddFloor";
import AddSubAccountProperties from "../../Components/Properties/AddSubAccountProperties";
import AddCoordinate from "../../Components/Properties/AddCoordinate";
import AddExcelFile from "../../Components/Properties/AddExcelFile";
import { AddExtraCharges } from "../../Components/Properties/AddExtraCharges";
import { IoFilter } from "react-icons/io5";
import PropertyFilterModal from "../../Components/FilterModals/PropertyFilterModal";
import SideModal from "../../Components/SideModal";

const Properties = ({ }) => {
  const { id: propId } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [viewDocument, setViewDocument] = useState(false);
  const [viewAddFloors, setViewAddFloors] = useState(false);
  const [fetchData, setFetchData] = useState([]);
  const [addSubAccount, setAddSubAccount] = useState(false);
  const [addCoordinate, setAddCoordinate] = useState(false);
  const [apiData, setApiData] = useState();
  const [addCharges, setAddCharges] = useState(null);
  const [viewExcelFile, setViewExcelFile] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState("");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(728, "days").format("YYYY-MM-DD"),
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const initialValues = {
    name: "",
    clientId: "",
    id: "",
    payuKey: "",
    payuMid: "",
    latitude: "",
    longitude: "",
    clientId: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("clientId", propId);

    // if (advancedFilter && advancedFilter.startsWith("ORDER_")) {
    //   body.append("filterType", "orderBy");
    //   body.append("filterValue", advancedFilter.replace("ORDER_", ""));
    // } else {
    //   body.append("filterType", filter);
    //   body.append("filterValue", filterValue);
    // }

    if (advancedFilter?.startsWith("ORDER_")) {
      body.append("filterType", "orderBy");
      body.append(
        "filterValue",
        advancedFilter.replace("ORDER_", "")
      );
    } else if (advancedFilter?.startsWith("RENT_")) {
      body.append("filterType", "createRent");
      body.append(
        "filterValue",
        advancedFilter.replace("RENT_", "")
      );
    } else if (advancedFilter?.startsWith("STATUS_")) {
      body.append("filterType", "status");
      body.append(
        "filterValue",
        advancedFilter.replace("STATUS_", "")
      );
    } else {
      body.append("filterType", filter);
      body.append("filterValue", filterValue);
    }

    body.append("startDate", startDate);
    // body.append("advancedFilter", advancedFilter);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/getproperties`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getPropertiesSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) error = true;
    else setApiData(res.data.data);
  };

  const getPropertiesError = (res) => { };

  const {
    isLoading,
    mutate: getPropertiesMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getPropertiesSuccess,
    onError: getPropertiesError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getPropertiesMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate, advancedFilter]);
  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getPropertiesMutate();
  };
  // const ChangeHandler = (e) => {
  //   setFilterValue(e.target.value);
  //   if (advancedFilter.startsWith("ORDER_")) {
  //     setAdvancedFilter("");
  //   }

  // };

  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);

    if (
      advancedFilter.startsWith("ORDER_") ||
      advancedFilter.startsWith("RENT_") ||
      advancedFilter.startsWith("STATUS_")
    ) {
      setAdvancedFilter("");
    }
  };

  //------- Edit Single Entry -------
  const EditPropertieFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("ownerMobile", values.ownerMobile);
    body.append("status", values.status);
    body.append("clientId", propId);
    body.append("lockInPeriod", values.lockInPeriod);
    body.append("noticePeriod", values.noticePeriod);
    body.append("pincode", values.pincode);
    body.append("streetAddress", values.streetAddress);
    body.append("address", values.address);
    // body.append("ownerName", values.ownerName);
    body.append("type", values.type);
    if (values.type === 1) {
      body.append("isGroundIncluded", values.isGroundIncluded);
    }

    // if (values.isGroundIncluded === 1) {
    //   body.append("isGroundIncluded", 1);
    // }

    body.append("floorCount", values.floorCount);
    body.append("isStampPaperRequired", values.isStampPaperRequired);

    return await axios.post(`${Config.apiUrl}/editproperty`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditEntrySuccess = (response) => {
    // response.data should have { status, msg, data }
    const resData = response?.data;

    if (resData?.status === "OK") {
      toast.success(resData.msg || "Property updated successfully");

      // Update your local state with new data
      if (resData.data) {
        setApiData(resData.data);
      }
    } else {
      // Handles backend validation errors, duplicates, or general errors
      toast.error(
        resData?.msg || "An error occurred while updating the property",
      );
    }

    // Reset UI selections
    getPropertiesMutate();
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (error) => {
    // Handles network or unexpected errors
    setEditUser(false);
    setSelectedData("");

    // Check if backend returned a message
    const errMsg =
      error?.response?.data?.msg ||
      "An error occurred while updating the property";
    toast.error(errMsg);

    console.error("Edit Property Error:", error);
  };
  const { isLoading: editEntryLoading, mutate: editPropertieMutate } =
    useMutation(EditPropertieFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });

  const getReportSuccess = (res) => {
    if (res?.statusText === "OK") {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(res.data);
      link.download = "exported_report.csv";

      link.click();
      toast.success(res?.data?.msg || "Report downloaded successfully");
    } else if (res.statusText === "NOK" || res.data.data === false) {
      toast.error(res?.data?.msg || "Error exporting report");
    }
  };

  const getReportError = (res) => {
    toast.error(error?.res?.data?.msg || "Error exporting report");
  };

  const { isLoading: isReportLoading, mutate: getReportMutate } = useMutation({
    onSuccess: getReportSuccess,
    onError: getReportError,
  });
  const handleButtonClick = () => {
    getReportMutate();
  };

  const DocumentUploadFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("clientId", values.clientId);
    body.append("eKyc", values.enableEKyc);
    body.append("policeVerification", values.enablePoliceVerification);
    body.append("createRent", values.createRentAgreement);
    body.append("isPanVerificationEnabled", values.isPanVerification);
    body.append("isPartialPaymentEnabled", values.isPartialPaymentEnabled);
    body.append("isStampPaperRequired", values.isStampPaperRequired);
    if (values.rentAgreement) {
      body.append("RentAgreement", values.rentAgreement);
    }
    body.append("ownerSignatureImage", values.ownerSignatureImage);
    body.append("isOnlinePaymentEnabled", values.enableOnlinePayment);

    return await axios.post(`${Config.apiUrl}/addrentagreement`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDocumentUploadSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      setApiData(data.data.data);
      // getPropertiesMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setViewDocument(false);
  };

  const onDocumentUploadError = (data) => {
    setViewDocument(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg);
  };

  const { isLoading: documentUploadLoading, mutate: documentUploadMutate } =
    useMutation(DocumentUploadFunction, {
      onSuccess: onDocumentUploadSuccess,
      onError: onDocumentUploadError,
    });

  const AddFloorFunction = async (values) => {
    const body = new FormData();
    body.append("propId", selectedData.id);
    body.append("numFloors", values.floorCount);
    body.append("clientId", propId);
    body.append("type", values.type);

    return await axios.post(`${Config.apiUrl}/addfloors`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const AddFloorSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
    }
    setApiData(data.data.data);
    setViewAddFloors(false);
    setSelectedData("");
  };

  const AddFloorError = (data) => {
    setViewAddFloors(false);
    toast.error(data?.response?.data?.msg);
    setSelectedData("");
  };
  const { isLoading: AddFloorLoading, mutate: AddFloorMutate } = useMutation(
    AddFloorFunction,
    {
      onSuccess: AddFloorSuccess,
      onError: AddFloorError,
    },
  );

  const AddExcelFilePost = async (excelData) => {
    const body = new FormData();
    body.append("filename", excelData[0]);
    body.append("clientId", selectedData.clientId);
    body.append("propId", selectedData.id);
    return await axios.post(`${Config.apiUrl}/uploadtenantfile`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };
  const AddExcelFileSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
    }
    setViewExcelFile(false);
    setSelectedData("");
  };
  const AddExcelFileError = (data) => {
    setViewExcelFile(false);
    toast.error(data?.response?.data?.msg);
    setSelectedData("");
  };
  const { isLoading: AddExcelFileLoading, mutate: AddExcelFileMutate } =
    useMutation(AddExcelFilePost, {
      onSuccess: AddExcelFileSuccess,
      onError: AddExcelFileError,
    });

  //  AddSubAccountProperties
  const AddSubAccountFunction = async (values) => {
    const body = new FormData();
    body.append("propId", values.id);
    body.append("clientId", values.clientId);
    body.append("payuMid", values.payuMid);
    body.append("payuKey", values.payuKey);
    return await axios.post(`${Config.apiUrl}/editsubaccountprop`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onAddSubAccountSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getPropertiesMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setAddSubAccount(false);
    setFetchData(data?.data?.data);
  };
  const onAddSubAccountError = (data) => {
    setSelectedData("");
    setAddSubAccount(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };
  const { isLoading: AddSubAccountLoading, mutate: AddSubAccountMutate } =
    useMutation(AddSubAccountFunction, {
      onSuccess: onAddSubAccountSuccess,
      onError: onAddSubAccountError,
    });

  // CoordinateFunction
  const AddCoordinateFunction = async (values) => {
    const body = new FormData();
    body.append("propId", values.id);
    body.append("clientId", selectedData.clientId);
    body.append("longitude", values.longitude);
    body.append("latitude", values.latitude);
    return await axios.post(`${Config.apiUrl}/updatecoordinates`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onAddCoordinateSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getPropertiesMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setAddCoordinate(false);
    setFetchData(data?.data?.data);
  };
  const onAddCoordinateError = (data) => {
    setSelectedData("");
    setAddCoordinate(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };
  const { isLoading: AddCoordinateLoading, mutate: AddCoordinateMutate } =
    useMutation(AddCoordinateFunction, {
      onSuccess: onAddCoordinateSuccess,
      onError: onAddCoordinateError,
    });

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Properties")}
                <span>/{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>

          {addCharges && (
            <AddExtraCharges setAddCharges={setAddCharges} data={apiData} />
          )}

          <SideModal
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          >
            <PropertyFilterModal
              handleClose={() => setIsFilterOpen(false)}
              onApplyFilter={(value) => {
                setAdvancedFilter(value);
                setIsFilterOpen(false);
              }}
              handleClearFilters={() => {
                setAdvancedFilter("");
              }}
              currentFilter={{ value: advancedFilter }}
            />
          </SideModal>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              handleButtonClick={handleButtonClick}
              isReportLoading={isReportLoading}
              setIsFilterOpen={setIsFilterOpen}
              setAdvancedFilter={setAdvancedFilter}
              t={t}
            />
          </div>
          {editUser && (
            <EditDetail
              editPropertieMutate={editPropertieMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetail
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}
          {viewDocument && (
            <ViewDocument
              setViewDocument={setViewDocument}
              selectedData={selectedData}
              documentUploadLoading={documentUploadLoading}
              documentUploadMutate={documentUploadMutate}
            />
          )}
          {viewAddFloors && (
            <AddFloor
              selectedData={selectedData}
              setViewAddFloors={setViewAddFloors}
              AddFloorMutate={AddFloorMutate}
              AddFloorLoading={AddFloorLoading}
            />
          )}
          {addSubAccount && (
            <AddSubAccountProperties
              AddSubAccountMutate={AddSubAccountMutate}
              initialValues={initialValues}
              AddSubAccountLoading={AddSubAccountLoading}
              setAddSubAccount={setAddSubAccount}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {addCoordinate && (
            <AddCoordinate
              AddCoordinateMutate={AddCoordinateMutate}
              initialValues={initialValues}
              AddCoordinateLoading={AddCoordinateLoading}
              setAddCoordinate={setAddCoordinate}
              data={data?.data}
              selectedData={selectedData}
            />
          )}
          {viewExcelFile && (
            <AddExcelFile
              selectedData={selectedData}
              setViewExcelFile={setViewExcelFile}
              AddExcelFileMutate={AddExcelFileMutate}
              AddExcelFileLoading={AddExcelFileLoading}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                setViewDocument={setViewDocument}
                setAddSubAccount={setAddSubAccount}
                setAddCoordinate={setAddCoordinate}
                userType={user.userType}
                setViewAddFloors={setViewAddFloors}
                setViewExcelFile={setViewExcelFile}
              />
              {(error || data?.data?.msg === "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  setIsFilterOpen,
  setAdvancedFilter,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");

  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-4 items-end flex-wrap">
            {filter !== "status" && filter !== "orderBy" ? (
              <InputGroup className="w-[200px]">
                <Label htmlFor="filterVal">{""}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  value={filterValue}
                  onChange={ChangeHandler}
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? ( // Render dropdown for "Status"
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select Status")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t("Select")}
                  </MenuItem>
                  <MenuItem value="1">{t("Pending")}</MenuItem>
                  <MenuItem value="2">{t("Completed")}</MenuItem>
                  <MenuItem value="3">{t("Active")}</MenuItem>
                  <MenuItem value="4">{t("Inactive")}</MenuItem>
                  <MenuItem value="5">{t("Deleted")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup className="" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  const selectedFilter = e.target.value;
                  setFilter(selectedFilter);
                  setAdvancedFilter("");

                  // Prefill "KIPN" for "GId" filter
                  if (selectedFilter === "gId") {
                    setFilterValue("KIPN");
                  } else {
                    setFilterValue(""); // Clear for other filters
                  }

                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
                <MenuItem value="gId">GId</MenuItem>
              </Select>
            </InputGroup>
            <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-md bg-white hover:bg-gray-100"
            >
              <IoFilter size={18} />
            </button>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default Properties;
